import React from 'react';

const Logo = (props) => {
  return (
    <img alt="Logo" src="/static/logo2.png" {...props} style={{ height: 50 }} />
  );
};

export default Logo;
